import { ReactNode, useState } from "react";
import { Box, Grid, IconButton, Menu } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid, GridColumnProps, LinkColumn } from "@roc/ui";
import { observer } from "mobx-react";
import { MoreVert } from "@material-ui/icons";
import { formatCurrency } from "@roc/ui/utils";

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    height: "65vh",
    overflow: "hidden",
  },
}));

interface LoanVendorGridInterface {
  store: any;
  columns: GridColumnProps[];
  selectModeEnabled: boolean;
  toolbar?: ReactNode;
  actions: (record, handleMenuClose) => ReactNode;
}

export const LoanVendorsGrid = observer(
  ({ store, columns, actions, toolbar }: LoanVendorGridInterface) => {
    const classes = useStyles();
    const { tab, gridStore } = store;
    const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);
    const menuOpen = Boolean(anchorEl);
    const [record, setRecord] = useState<any>({});

    const frameworkComponents = {
      currencyCellRenderer: (params) => (
        <Box textAlign="right">{formatCurrency(params.value, 0)}</Box>
      ),
      actionCellRenderer: (params) => {
        return (
          <>
            <IconButton
              onClick={(e) => {
                openMenu(e, params.node.data);
              }}
            >
              <MoreVert color="primary" />
            </IconButton>
          </>
        );
      },
    };

    const onSortChanged = (params) => {
      const sortModel = params.api.getSortModel();
      gridStore.setSortModel(sortModel);
    };

    const onFilterChanged = (params) => {
      const filterModel = params.api.getFilterModel();
      gridStore.setFilterModel(filterModel);
    };

    const openMenu = (event: React.MouseEvent<HTMLElement>, record) => {
      setRecord(record);
      setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
      setAnchorEl(null);
    };

    return (
      <Box>
        <Grid item className={classes.gridContainer}>
          <DataGrid
            columns={columns}
            rows={gridStore.gridData.data.rows}
            frameworkComponents={frameworkComponents}
            onSortChanged={onSortChanged}
            onFilterChanged={onFilterChanged}
            isLoading={gridStore.isLoading}
            showFilters={gridStore.showFilters}
            sortModel={gridStore.sortModel}
            filterModel={gridStore.filterModel}
            paginationData={gridStore.gridData.meta}
            setPageNumber={gridStore.setPageNumber}
            toolbar={toolbar}
          />
        </Grid>
        <Menu
          id="menu-appbar"
          getContentAnchorEl={null}
          anchorEl={anchorEl}
          keepMounted
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          open={menuOpen}
          onClose={handleMenuClose}
        >
          {actions(record, handleMenuClose)}
        </Menu>
      </Box>
    );
  }
);
